// import React from "react";
// // import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
// // import PhoneIcon from '@material-ui/icons/Phone';
// // import EmailIcon from '@material-ui/icons/Email';
// import "./Support.css"; // Add your styles here

// const Support = () => {
//   const query_dp = `${process.env.PUBLIC_URL}/custom-icons/query-dp.png`;

//   return (
//     <div className="support-container">
//       <div className="support-popup-image">
//         <img src={query_dp} alt="Support" className="support-image" />
//       </div>
//       <div className="support-popup-text">
//         <h3>Support</h3>
//         <p>If you need any help contact us</p>
//         <div className="support-details">
//           <div className="support-item">
//             {/* <HelpOutlineIcon style={{ color: "#e91e63" }} /> */}
//             <span className="support-link">Help desk</span>
//           </div>
//           <div className="support-item">
//             {/* <PhoneIcon style={{ color: "#e91e63" }} /> */}
//             <span>+39040303020</span>
//           </div>
//           <div className="support-item">
//             {/* <EmailIcon style={{ color: "#e91e63" }} /> */}
//             <span>support@surveyorsai.com</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Support;

import React from "react";
import "./Support.css"; // Import your custom styles

const Support = () => {
  const query_dp = `${process.env.PUBLIC_URL}/custom-icons/query-dp.png`; // Path to the main image
  const helpIcon =  `${process.env.PUBLIC_URL}/custom-icons/query_pink.png`; // Path to help icon
  const phoneIcon = `${process.env.PUBLIC_URL}/custom-icons/phone.png`; // Path to phone icon
  const emailIcon = `${process.env.PUBLIC_URL}/custom-icons/email.png`; // Path to email icon

  return (
    <div className="support-container">
      <div className="support-popup-image">
        <img src={query_dp} alt="Support" className="support-image" />
      </div>
      <div className="support-popup-text">
        <h3>Support</h3>
        <p>If you need any help, contact us</p>
        <div className="support-details">
          <div className="support-item">
            <img src={helpIcon} alt="Help Desk" className="support-icon" />
            <span className="support-link">Help desk</span>
          </div>
          <div className="support-item">
            <img src={phoneIcon} alt="Phone" className="support-icon" />
            <span className="support-link">+39040303020</span>
          </div>
          <div className="support-item">
            <img src={emailIcon} alt="Email" className="support-icon" />
            <span className="support-link">support@surveyorsai.com</span>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default Support;
